import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "./app-config.service";
@Injectable({
    providedIn: 'root'
})

export class eplService {
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    apiUrl = AppConfig.settings.apiUrl;

    constructor(private http: HttpClient) {

    }

    getEplData(reqData: any) {
        return (
            this.http.post<any>(`${this.apiUrl}EPL/GetEPLSearch`, reqData, this.httpOptions)

        )
    }

    getEplDetails(reqData: any) {
        return (
            this.http.post<any>(`${this.apiUrl}EPL/GetEPLDetails`, reqData, this.httpOptions)

        )
  }

  validateEplDetails(searchItem: any, addItem:any) {
    let params = [];
    params.push(`searchItem=${searchItem}&addItem=${addItem}`);
    let url = params.length > 0 ? `?${params.join('&')}` : "";
    return (
      this.http.get<any>(`${this.apiUrl}EPL/ValidateAddItemInBranches${url}`, this.httpOptions)

    )
  }

    searchValidItem(payload: any) {
        return (
            this.http.get<any>(`${this.apiUrl}EPL/GetEPLDeleteSearch?CRId=${payload.CRId}&item=${payload.item}`, this.httpOptions)
        )
    }
    deleteObselute(payload: any) {
        return (
            this.http.post<any>(`${this.apiUrl}EPL/EPLDeleteItem`, payload, this.httpOptions)
        )
    }
    deleteReplaceObselute(payload: any) {
        return (
            this.http.post<any>(`${this.apiUrl}EPL/EPLDeleteandReplaceItem`, payload, this.httpOptions)
        )
    }

    getObseluteGridData(payload: any) {
        return (
            this.http.get<any>(`${this.apiUrl}EPL/ViewEPLObsoleteItem?CRId=${payload}`, this.httpOptions)
        )
    }

    getMasterGridData(payload: any) {
        return (
            this.http.get<any>(`${this.apiUrl}EPL/EPLHeaderGrid?CRId=${payload}`, this.httpOptions)
        )
    }

    getChildGridData(payload: any) {
        return (
            this.http.get<any>(`${this.apiUrl}EPL/EPLBomItemsGrid?CRId=${payload}`, this.httpOptions)
        )
    }

    undoObselute(payload: any) {
        return (
            this.http.post<any>(`${this.apiUrl}EPL/EPLUndoitems`, payload, this.httpOptions)
        )
    }

    deleteEplLineItem(payload: any) {
        return (
            this.http.post<any>(`${this.apiUrl}EPL/EPLUndoitems`, payload, this.httpOptions)
        )
    }

    getItemShortPopupData(skip: number, pageSize: number = 5, searchText: string) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return (
            this.http.get<any>(`${this.apiUrl}EPL/GetEPLBuildPopUp${url}`, this.httpOptions)
        )
    }

    addEpl(crId: number, tag: string) {
        let params = [];
        params.push(`CRID=${crId}&Tag=${tag}`);
        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return (
            this.http.post<any>(`${this.apiUrl}EPL/AddEPLBuild${url}`, null, this.httpOptions)
        )
    }

    updateEpl(crId: number, isCombined: any, payload: any) {
        let params = [];
        params.push(`CRID=${crId}&IsCombineTag=${isCombined}`);
        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.post<any>(`${this.apiUrl}EPL/UpdateEPLBuild${url}`, payload, this.httpOptions);
    }

    validateEpl(crId: number, tag: any) {
        let params = [];
        params.push(`CRID=${crId}&Tag=${tag}`);
        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.post<any>(`${this.apiUrl}EPL/ValidateEPLRequest${url}`, null, this.httpOptions);
    }

    saveAndAddToCR(crNo: number, payload: any) {
        return this.http.post<any>(`${this.apiUrl}EPL/SaveAndAddToCR?CRID=${crNo}`, payload, this.httpOptions);
    }

    deleteSelectedHeader(payload: any) {
        return this.http.post<any>(`${this.apiUrl}EPL/DeleteChangeRequestItems`, payload, this.httpOptions);
    }

    importEPLBuild(crNo: number, payload: any) {
        return this.http.post<any>(`${this.apiUrl}EPL/ImportEPLBuild?CRID=${crNo}`, payload, this.httpOptions);
    }

    addDeleteItems(payload: any, isAdd: boolean = false) {
        let url = isAdd ? 'AddItems' : 'DeleteItems';
        return this.http.post<any>(`${this.apiUrl}EPL/${url}`, payload, this.httpOptions);
    }

    addDeleteItemsResult(payload: any, isAdd: boolean = false) {
        let url = isAdd ? 'AddItemsResult' : 'DeleteItemsResult';
        return this.http.post<any>(`${this.apiUrl}EPL/${url}`, payload, this.httpOptions);
    }

    getEquipTag(skip: number, pageSize: number = 5, searchText: string) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}EPL/GetEplbuildPopup${url}`, this.httpOptions);
    }

    getEplTag(payload: any) {
        return this.http.post(`${this.apiUrl}EPL/GetEplTag`, payload, this.httpOptions);
    }

    addEplTag(payload: any) {
        return this.http.post(`${this.apiUrl}EPL/AddEplTag`, payload, this.httpOptions);
    }

    deleteBomItemsUsingPopup(payload: any) {
        return this.http.post(`${this.apiUrl}EPL/DeleteBomItemsUsingPopup`, payload, this.httpOptions);
    }

    getExportData(crId: any) {
        return (
            this.http.get<any>(`${this.apiUrl}EPL/GetBomItemsExportByCRId?CRId=${crId}`, this.httpOptions)
        )
    }

    getSubAssemblyForEPLPopUp(changeItemEplId: any) {
        return (
            this.http.get<any>(`${this.apiUrl}EPL/GetSubAssemblyForEPLPopUp?changeItemEplId=${changeItemEplId}`, this.httpOptions)
        )
    }
}
